<template>
  <div class="m-row" :class="{ 'is-editable': isEditMode }" ref="mediaRow">
    <div
      class="c-pb__row col-xs-12 col-md-6"
      :style="`flex: ${leftColumnWidth}`"
      style="max-width: 100%"
      @click="editElement($el, leftColumnData, 'leftColumn')"
    >
      <p v-if="!leftColumnData">Click to edit</p>
      <pb-element :element="leftColumnData" v-else></pb-element>
    </div>

    <div
      class="c-pb__row col-xs-12 col-md-6"
      :style="`flex: ${rightColumnWidth}`"
      style="max-width: 100%"
      @click="editElement($el, rightColumnData, 'rightColumn')"
    >
      <p v-if="!rightColumnData">Click to edit</p>
      <pb-element :element="rightColumnData" v-else></pb-element>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import PbElement from "@/components/PbElement";
import elementClosest from "element-closest";

elementClosest(window);

export default {
  name: "BaseRow",

  props: {
    leftColumn: {
      type: [String, Object],
      default: () => {},
    },
    rightColumn: {
      type: [String, Object],
      default: () => {},
    },
    leftColumnWidth: {
      type: [Number, String],
      default: 6,
    },
    rightColumnWidth: {
      type: [Number, String],
      default: 6,
    },
  },

  // comp
  methods: {
    editElement(el, elem = {}, column) {
      /**
       * need to determin the index of this row within the parent
       * so that we can update, i.e. the leftColumn property of item 3
       *  make sense to me anyway
       **/
      const theRow = el.closest(".c-pb__row");
      const rowNum = [...theRow.parentElement.children].indexOf(theRow);

      this.$store.commit("pageElements/setParentRow", {
        rowNum: rowNum,
        column: column,
      });
      // tell the store we are editing now
      this.$store.commit("pageElements/setCurrentElement", elem);
      this.$store.commit("pageElements/setModalOpen", true);
      this.$store.commit("pageElements/setEditMode", true);
    },
  },

  computed: {
    isEditMode() {
      // return true
      if (this.$refs.mediaRow) {
        return this.$refs.mediaRow.closest(".c-pb__row").length > -1;
      }
      return false;
    },
    leftColumnData: {
      get() {
        const element =
          typeof this.leftColumn === "string"
            ? JSON.parse(this.leftColumn)
            : this.leftColumn;

        if (element.type == "media-file" && element.isUpload) {
          element.type = "media-file-upload";
        }

        return element;
      },
      set(newVal) {
        this.$emit("onLeftColumnUpdate", newVal);
      },
    },
    rightColumnData: {
      get() {
        const element =
          typeof this.rightColumn === "string"
            ? JSON.parse(this.rightColumn)
            : this.rightColumn;

        if (element.type == "media-file" && element.isUpload) {
          element.type = "media-file-upload";
        }

        return element;
      },
      set(newVal) {
        $emit("onRightColumnUpdate", newVal);
      },
    },
  },

  components: {
    draggable,
    PbElement,
  },
};
</script>

<style scoped lang="scss">
.m-row {
  display: flex;
  margin: 0 -1em;
}

.c-pb__row {
  // margin-left: 10px;
  // margin-right: 10px;
  box-sizing: border-box;

  > * {
    margin-top: 0;
    margin-bottom: 1em;
  }

  > .m-row {
    margin-top: 3rem;
  }

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }
}

.c-pb__drag-zone--inner {
  border: 2px dashed $colour-nhs-med-grey;
  text-align: center;
  padding: 3vmax;
}
</style>
